import { resolveName } from 'components/form'
import { useEffect } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoPerguntaStatusEnum,
  PassouFalhouEnum,
} from '../model-consultaSeguimento'

interface Props<T extends ConsultaSeguimentoAplicacaoItemModel> {
  name: MetaPath<T>
  conditionToCalculate: ((values: T) => boolean) | boolean
  calculateResultado(values: T): PassouFalhouEnum
}

export function useConsultaSeguimentoSetResultado<T extends ConsultaSeguimentoAplicacaoItemModel>(props: Props<T>) {
  const { name, conditionToCalculate, calculateResultado } = props

  const resolvedCondition =
    typeof conditionToCalculate === 'function' ? conditionToCalculate : () => conditionToCalculate

  const {
    input: { value },
  } = useField<T>(resolveName(name), {
    subscription: { value: true },
  })

  const {
    input: { onChange: setResultado },
  } = useField<PassouFalhouEnum>(resolveName(name.resultado), { subscription: {} })

  const {
    input: { onChange: setStatus },
  } = useField<ConsultaSeguimentoPerguntaStatusEnum>(resolveName(name.status), { subscription: {} })

  useEffect(() => {
    if (resolvedCondition(value)) {
      if (calculateResultado(value) === PassouFalhouEnum.PASSOU) {
        setResultado(PassouFalhouEnum.PASSOU)
        setStatus(ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU)
      } else {
        setResultado(PassouFalhouEnum.FALHOU)
        setStatus(ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU)
      }
    } else {
      setResultado(null)
      setStatus(ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO)
    }
  }, [calculateResultado, resolvedCondition, setResultado, setStatus, value])
}
